import { ReplaySubject } from 'rxjs';
import { basketConfigCh, basketConfigDe, basketConfigUk, basketConfigUs, } from '../../const/basket-local-configs';
export class BasketConfig {
    constructor(config) {
        this.config = config;
        this.configDataLoaded = new ReplaySubject();
        this.siteContextMap = {
            us: basketConfigUs,
            uk: basketConfigUk,
            de: basketConfigDe,
            ch: basketConfigCh,
        };
        this.localBasketConfig = basketConfigUs;
    }
    get configDataLoaded$() {
        return this.configDataLoaded.asObservable();
    }
    fetchConfigData(site = 'us', siteContext = 'ishares', type = 'basket') {
        return this.config.getConfig(siteContext, site, type);
    }
    setConfigData(basketConfigData) {
        this.configData = basketConfigData;
        this.configDataLoaded.next();
    }
    getFundCardConfig() {
        return this.configData ? this.configData.fundCard : null;
    }
    getDataPointsConfig() {
        return this.configData ? this.configData.dataPoints : null;
    }
    getDeniedProductTypesConfig() {
        return this.configData ? this.configData.deniedProductTypes : null;
    }
    setLocalBasketConfig(siteContext) {
        if (siteContext) {
            this.localBasketConfig = this.siteContextMap[siteContext]
                ? this.siteContextMap[siteContext]
                : basketConfigUs;
        }
    }
}
